import React from "react";
import { X } from "lucide-react";

const SHORTCUTS = [
  { category: "Navigace", items: [
    { keys: ["Ctrl", "K"], desc: "Otevřít vyhledávání" },
    { keys: ["G", "D"], desc: "Přejít na Dashboard" },
    { keys: ["G", "C"], desc: "Přejít na Kalendář" },
    { keys: ["G", "T"], desc: "Přejít na Úkoly" },
    { keys: ["G", "P"], desc: "Přejít na Projekty" },
    { keys: ["G", "Z"], desc: "Přejít na Zákazníky" },
    { keys: ["G", "N"], desc: "Přejít na Nabídky" },
  ]},
  { category: "Obecné", items: [
    { keys: ["?"], desc: "Zobrazit klávesové zkratky" },
    { keys: ["Esc"], desc: "Zavřít dialog / modal" },
  ]},
];

export default function KeyboardShortcutsDialog({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" data-testid="shortcuts-dialog">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md mx-4 bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <h2 className="text-sm font-semibold text-slate-800">Klávesové zkratky</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 p-1 rounded-lg hover:bg-slate-100"
            data-testid="shortcuts-close-btn">
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Content */}
        <div className="px-5 py-4 max-h-[60vh] overflow-y-auto space-y-5">
          {SHORTCUTS.map(section => (
            <div key={section.category}>
              <h3 className="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">
                {section.category}
              </h3>
              <div className="space-y-1.5">
                {section.items.map((item, idx) => (
                  <div key={idx} className="flex items-center justify-between py-1">
                    <span className="text-sm text-slate-600">{item.desc}</span>
                    <div className="flex items-center gap-1">
                      {item.keys.map((key, kIdx) => (
                        <React.Fragment key={kIdx}>
                          {kIdx > 0 && <span className="text-[10px] text-slate-300">+</span>}
                          <kbd className="min-w-[24px] h-6 flex items-center justify-center px-1.5 rounded bg-slate-100 border border-slate-200 text-[11px] font-mono text-slate-600">
                            {key}
                          </kbd>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="px-5 py-3 border-t border-slate-100 bg-slate-50/50">
          <p className="text-[10px] text-slate-400 text-center">
            Stiskněte <kbd className="px-1 py-0.5 rounded bg-slate-100 text-[10px] font-mono">?</kbd> kdykoli pro zobrazení zkratek
          </p>
        </div>
      </div>
    </div>
  );
}
